<app-page-heading [key]="'realtime-tracking.track-a-trip.page-title'"
                  [subheadingIcon]="'fa fa-truck'"
                  [disableMarginBottom]="true"
></app-page-heading>

<app-load-tracking-map [singleTrip]="true"
                       [(showForecastPath)]="showForecastPath"
                       [canShowDebug]="false"
                       [(selectedTrip)]="trip"
                       [forecastPathReady]="forecastPathReady"
                       [(distanceUnit)]="distanceUnit"
                       (centerViewEmitter)="centerView()"
                       (mapReady)="onMapReady($event)"
                       (refreshEmitter)="forceRefreshTripDetails(trip)">
</app-load-tracking-map>
